(() => {
  function iniciar(raiz) {
    if (raiz.dataset.listo) return;
    raiz.dataset.listo = '1';
    const $ = (nombre) => raiz.querySelector(`[data-is="${nombre}"]`);
    const pedir = (ruta, opciones) => window.ImaginaSer.pedir(raiz.dataset.api, ruta, opciones);
    if (raiz.dataset.isPagina === 'adventure-box') {
      $('espera').addEventListener('submit', async (evento) => {
        evento.preventDefault();
        const form = evento.currentTarget;
        const boton = form.querySelector('button');
        boton.disabled = true; boton.textContent = 'Inscribiendo…'; $('mensaje').textContent = '';
        try {
          await pedir('/api/lista-espera', {method:'POST',headers:{'content-type':'application/json'},body:JSON.stringify({email:form.elements.email.value.trim(),whatsapp:form.elements.whatsapp.value.trim(),producto:'adventure-box'})});
          $('mensaje').textContent = '¡Listo! Te avisaremos antes que a nadie cuando la Adventure Box esté disponible.';
        } catch (e) { $('mensaje').textContent = e.message; }
        finally { boton.disabled = false; boton.textContent = 'Avísame primero'; }
      });
    }
    if (raiz.dataset.isPagina === 'biblioteca') iniciarBiblioteca(raiz, $, pedir);
  }
  function crear(etiqueta, clase, texto) {
    const el = document.createElement(etiqueta);
    if (clase) el.className = clase;
    if (texto) el.textContent = texto;
    return el;
  }
  function estadoLibro(c) {
    if (!c.pagado) return { texto: 'Vista previa', boton: 'Completar mi libro', clase: 'previa' };
    if (c.estado === 'completo') return { texto: 'Listo para leer', boton: 'Leer mi libro', clase: 'listo' };
    if (c.estado === 'error') return { texto: 'Lo estamos revisando', boton: 'Ver mi libro', clase: 'revision' };
    return { texto: 'Creando tu libro…', boton: 'Ver avance', clase: 'creando' };
  }
  function iniciarBiblioteca(raiz, $, pedir) {
    const pestanas = [...raiz.querySelectorAll('[data-is-tab]')];
    const mostrar = (nombre, foco) => {
      for (const p of pestanas) {
        const activa = p.dataset.isTab === nombre;
        p.setAttribute('aria-selected', activa); p.tabIndex = activa ? 0 : -1;
        raiz.querySelector(`#${p.getAttribute('aria-controls')}`).hidden = !activa;
        if (activa && foco) p.focus();
      }
    };
    pestanas.forEach((p, i) => {
      p.addEventListener('click', () => { mostrar(p.dataset.isTab); history.replaceState(null, '', `#${p.dataset.isTab}`); });
      p.addEventListener('keydown', (e) => {
        const paso = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
        if (paso) mostrar(pestanas[(i + paso + pestanas.length) % pestanas.length].dataset.isTab, true);
      });
    });
    const desdeHash = () => { const h = location.hash.slice(1); if (pestanas.some((p) => p.dataset.isTab === h)) mostrar(h); };
    desdeHash();
    window.addEventListener('hashchange', desdeHash);
    if (!window.ImaginaSerCliente) return;

    $('mensaje').textContent = 'Abriendo tu biblioteca…';
    pedir('/api/yo').then((datos) => {
      $('mensaje').textContent = '';
      $('descuento').hidden = !datos.cuentos.some((c) => c.pagado);

      const personajes = $('personajes'); personajes.replaceChildren();
      if (!datos.personajes.length) personajes.append(crear('p', 'is-bib-vacio', 'Aquí aparecerán tus personajes ilustrados.'));
      for (const p of datos.personajes) {
        const tarjeta = crear('article', 'is-bib-cromo');
        const marco = crear('div', 'is-bib-cromo-foto');
        const img = crear('img'); img.src = p.imagen; img.alt = p.nombre; img.loading = 'lazy'; img.width = 300; img.height = 300;
        img.onerror = () => { img.remove(); marco.textContent = '✦'; };
        marco.append(img);
        const sello = crear('span', `is-bib-sello${p.conservar ? ' is-guardado' : ''}`, p.conservar ? '★ Guardado para siempre' : 'Se guarda al comprar su libro');
        const enlace = crear('a', 'is-bib-boton is-chico', `Nueva aventura con ${p.nombre}`);
        enlace.href = `/pages/crear-cuento?personaje=${encodeURIComponent(p.id)}`;
        tarjeta.append(marco, crear('h3', '', p.nombre), sello, enlace);
        personajes.append(tarjeta);
      }

      const repisa = $('cuentos'); repisa.replaceChildren();
      const libros = [...datos.cuentos].sort((a, b) => Number(b.pagado) - Number(a.pagado));
      if (!libros.length) repisa.append(crear('p', 'is-bib-vacio', 'Tu primera aventura está por comenzar.'));
      for (const c of libros) {
        const estado = estadoLibro(c);
        const libro = crear('a', `is-bib-libro is-${estado.clase}`);
        libro.href = `/pages/mi-cuento?id=${encodeURIComponent(c.id)}`;
        const tapa = crear('div', 'is-bib-tapa');
        const img = crear('img'); img.src = c.portada; img.alt = ''; img.loading = 'lazy'; img.width = 400; img.height = 400;
        img.onerror = () => { img.remove(); tapa.textContent = '✦'; };
        tapa.append(img);
        libro.append(tapa, crear('h3', '', c.titulo || 'Mi cuento'), crear('span', 'is-bib-estado', estado.texto), crear('span', 'is-bib-boton is-chico', estado.boton));
        repisa.append(libro);
      }

      for (const celda of raiz.querySelectorAll('[data-is-pedido]')) {
        if (celda.textContent === 'Cancelado') continue;
        const cuento = datos.cuentos.find((c) => c.pedido === celda.dataset.isPedido);
        celda.textContent = cuento ? `${cuento.titulo || 'Mi cuento'} · ${estadoLibro(cuento).texto}` : 'Pago en revisión';
      }
      const tel = $('telefono');
      if (tel && tel.textContent === '—' && datos.cliente.whatsapp) tel.textContent = datos.cliente.whatsapp;
      const formulario = $('whatsapp');
      if (formulario) {
        formulario.elements.whatsapp.value = datos.cliente.whatsapp || '';
        formulario.addEventListener('submit', async (e) => {
          e.preventDefault();
          const boton = formulario.querySelector('button');
          boton.disabled = true; boton.textContent = 'Guardando…';
          try {
            const r = await pedir('/api/yo', { method: 'PUT', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ whatsapp: formulario.elements.whatsapp.value.trim() }) });
            formulario.elements.whatsapp.value = r.whatsapp; boton.textContent = '¡Guardado!';
          } catch (error) { $('mensaje').textContent = error.message; boton.textContent = 'Guardar'; }
          finally { boton.disabled = false; setTimeout(() => { boton.textContent = 'Guardar'; }, 2500); }
        });
      }
    }).catch((e) => { $('mensaje').textContent = e.estado === 401 ? 'Tu sesión expiró. Vuelve a iniciar sesión.' : e.message; });
  }
  const todos = () => document.querySelectorAll('[data-is-pagina]').forEach(iniciar);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',todos); else todos();
  document.addEventListener('shopify:section:load',todos);
})();
